module.exports = __webpack_public_path__ + "assets/img/w-c-12.216839ef.png";